/** @format */

import styled from 'styled-components';
import bgImg from '../images/pg_bg.webp';
import { Link } from 'react-router-dom';
export const Container = styled.div`
  width: min(120rem, 100%);
  margin: 0 auto;
  background-image: url(${bgImg});
  background-size: cover;
  .footer_container {
    width: min(80rem, 95%);
    margin: 0 auto;
  }
`;

export const MainContainer = styled.div`
  width: min(470px, 95%);
  margin: 0 auto;
  .image_wrapper {
    width: min(13.6856rem, 95%);
    margin: 0 auto;
    position: relative;
    .image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .message_box {
    margin-block: 3rem;
    .error_heading {
      font-family: Roboto;
      font-size: 18px;
      font-weight: 400;
      line-height: 21.09px;
      letter-spacing: 0.2em;
      text-align: center;
      color: #aaaaaa;
      margin: 0;
      text-transform: uppercase;
    }
    .not_found_numbers {
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        font-family: Montserrat;
        font-size: 8rem;
        font-weight: 700;
        line-height: 8.7519rem;
        text-align: center;
        color: #fafafc;
        -webkit-text-stroke-color: black;
        -webkit-text-stroke-width: 0.125rem;
      }
      .second_number {
        margin-left: -18px;
      }
      .third_number {
        margin-left: -15px;
      }
    }
    .message {
      font-family: Roboto;
      font-size: 1.25rem;
      font-weight: 400;
      line-height: 1.465rem;
      text-align: center;
      color: var(--Light-Grey---Input-Text, #d9d9d9);
    }
  }
`;

export const ButtonLink = styled(Link)`
  display: block;
  text-decoration: none;
  margin: 0 auto;
  width: fit-content;
  background: #13131a;
  font-family: Roboto;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.3181rem;
  text-align: left;
  color: var(--Black, #13131A);
  padding: 0.9375rem 1.25rem 0.9375rem 1.25rem;
  border-radius: 0.5rem;
  background: linear-gradient(96.14deg, #d9d9d9 0%, #ffffff 100%);
`;
